import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import TableCell from '@material-ui/core/TableCell/TableCell';
import PropTypes from 'prop-types';
import clsx from 'clsx';

const CustomTableCell = ({
  classes, children, shrink, nobreak, align,
}) => (
  <TableCell
    align={align}
    className={clsx(classes.body, shrink && classes.shrink, nobreak && classes.nobreak)}
  >
    {children}
  </TableCell>
);

CustomTableCell.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.any,
  align: PropTypes.string,
  shrink: PropTypes.bool,
  nobreak: PropTypes.bool,
};

CustomTableCell.defaultProps = {
  children: '',
  align: 'inherit',
  shrink: false,
  nobreak: false,
};

const styles = () => ({
  body: {
    fontSize: '1rem',
    padding: '0.5rem',
  },
  shrink: {
    width: '0.1%',
  },
  nobreak: {
    whiteSpace: 'nowrap',
  },
});

export default withStyles(styles)(CustomTableCell);
